

const tip_of_the_day = [
    "Your Magical Defenses (mDEF) are a combination of your Mind and Presence.",
    "Your Physical Defenses (pDEF) are a combination of your Endurance and Vitality.",
    "Don't forget to refresh at the top of the round!",
    "Make sure you check that your equipment isn't too heavy. Heavier equipment can make it harder to dodge.",
    "Don't forget to take notes!",
    "If you forget your password... try \"tommysux\" instead! ",
    "Press [F] to pay respects.",
]

export default tip_of_the_day;